function required(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (!value)
    throw new Error(`Missing ${name}. Copy apps/web/.env.example to apps/web/.env.local.`);
  return value;
}

export const env = {
  apiUrl: required('VITE_API_URL').replace(/\/$/, ''),
  supabaseUrl: required('VITE_SUPABASE_URL'),
  supabasePublishableKey: required('VITE_SUPABASE_PUBLISHABLE_KEY'),
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || undefined,
};
